const illegalFileReg = /[^(\u4e00-\u9fa5)\w\（\）\(\)\“\”\"\'\【\】\.\+\-\&]/;

export function uploadFileVerify(fileName) {
  if (illegalFileReg.test(fileName)) {
    return Promise.reject('文件名只可以包含以下特殊字符（/ . () “” 【】 + - &）');
  }
  return Promise.resolve();
}


// 左匹配查询时过滤字符%_串，避免全量查询
export function filterStr(str) {
  let specialStr = '';
  if (str !== '' && str !== null && str !== undefined) {
    const pattern = new RegExp('%_');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < str.length; i++) {
      specialStr += str.substr(i, 1).replace(pattern, '');
    }
    return specialStr;
  }
  return specialStr;
}
